import { render, staticRenderFns } from "./LocalizationsPage.vue?vue&type=template&id=219f90f1&scoped=true&"
import script from "./LocalizationsPage.vue?vue&type=script&lang=js&"
export * from "./LocalizationsPage.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationsPage.vue?vue&type=style&index=0&id=219f90f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f90f1",
  null
  
)

export default component.exports